<template>
  <transition name="fade">
    <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-40 backdrop-blur-sm">
      <div class="bg-card rounded-2xl shadow-2xl w-full max-w-md p-8 flex flex-col items-center animate-fadeIn">
        <button @click="$emit('cancel')" aria-label="Close modal" class="absolute top-4 right-4 text-muted-foreground hover:text-foreground text-2xl focus:outline-none">
          <i class="fas fa-times"></i>
        </button>
        <div class="flex flex-col items-center w-full">
          <div class="bg-yellow-500/15 rounded-full p-5 mb-4 flex items-center justify-center">
            <i class="fas fa-exclamation-circle text-yellow-600 dark:text-yellow-400 text-3xl"></i>
          </div>
          <h3 class="text-2xl font-bold text-foreground mb-2 text-center">Complete Onboarding to Apply</h3>
          <p class="text-muted-foreground mb-6 text-center text-base">
            You need to complete your onboarding profile before you can apply for jobs. This helps us match you with the best opportunities.
          </p>
          <div class="w-full border-t border-border mb-6"></div>
          <div class="flex flex-col sm:flex-row gap-3 w-full">
            <button @click="$emit('cancel')" class="flex-1 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-accent transition font-medium border border-border">Cancel</button>
            <button @click="$emit('complete')" class="flex-1 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary-dark transition font-medium shadow">Go to Onboarding</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OnboardingRequiredModal',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.animate-fadeIn {
  animation: fadeIn 0.3s;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}
@media (max-width: 640px) {
  .max-w-md {
    max-width: 95vw;
  }
}
</style> 